import titleStyles from './title';

function hasHeading() {
  var H1s = document.getElementsByTagName('h1').length;
  var errBlock = document.getElementById('errMsg');
  if (errBlock && H1s > 0) {
    errBlock.style.display = "block";
  }
}
window.onload = hasHeading();
